import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const CreateCreditCardTypeBinNumbers = (data: any) =>
    request({
        url: ApiURL.Command.CreateCreditCardTypeBinNumbers,
        method: RequestType.POST,
        data: data,
    });

const CreateCreditCardTypeBinNumbersBulk = (data: any) =>
    request({
        url: ApiURL.Command.CreateCreditCardTypeBinNumbersBulk,
        method: RequestType.POST,
        data: data,
    });

const CreateBlackListedCreditCards = (data: any) =>
    request({
        url: ApiURL.Command.CreateBlackListedCreditCards,
        method: RequestType.POST,
        data: data,
    });

const CreateBlackListedCreditCardsBulk = (data: any) =>
    request({
        url: ApiURL.Command.CreateBlackListedCreditCardsBulk,
        method: RequestType.POST,
        data: data,
    });

const DeleteCreditCardTypeBinNumbers = (id: string) =>
    request({
        url: ApiURL.Command.DeleteCreditCardTypeBinNumbers.replace('{id}', id),
        method: RequestType.DELETE,
    });

const DeleteBlackListedCreditCards = (id: string) =>
    request({
        url: ApiURL.Command.DeleteBlackListedCreditCards.replace('{id}', id),
        method: RequestType.DELETE,
    });

const BinNumberCommand = {
    CreateCreditCardTypeBinNumbers,
    CreateCreditCardTypeBinNumbersBulk,
    CreateBlackListedCreditCards,
    CreateBlackListedCreditCardsBulk,
    DeleteCreditCardTypeBinNumbers,
    DeleteBlackListedCreditCards,
};

export default BinNumberCommand;